// HOOKS
import { useContext } from "react";
// COMPONENTS
import Card from "../../components/cards/card.jsx";
// CONTEXT
import { ProductsContext } from "../../context/products.context.jsx";

const CATAGORIES = [
  { name: "iPads", id: "ipads", link: "/category/ipads/make/apple" },
  { name: "MacBooks", id: "macbooks", link: "category/macbooks/make/apple" },
  { name: "Chromebooks", id: "chromebooks", link: "category/chromebooks" },
];

const CLASSNAMES = {
  section: "flex flex-col h-full m-auto",
  p1: "p-2 font-bold flex justify-center text-center",
  p2: "p-2 flex justify-center text-center",
  container:
    "items-center justify-center flex-wrap px-8 py-24 gap-4 flex flex-row",
};

const Page = ({ classNames = CLASSNAMES }) => {
  const { categories } = useContext(ProductsContext);

  return (
    <section className={classNames?.section || CLASSNAMES.section}>
      <p className={classNames?.p1 || CLASSNAMES.p1}>
        Welcome to the TCS repairs price list. Below you will find our price
        list for our most common repairs.
      </p>
      <p className={classNames?.p2 || CLASSNAMES.p2}>
        If you don't see your device listed, please call us at 913-717-7779 for
        a custom quote.
      </p>
      <div className={classNames?.container || CLASSNAMES.container}>
        {categories?.map((catagory, index) => (
          <Card
            key={`${catagory.name}-${index}`}
            label={catagory.name}
            link={`${catagory.link}`}
          />
        )) ||
          CATAGORIES.map((catagory) => (
            <Card
              key={catagory.id}
              label={catagory.name}
              link={`${catagory.link}`}
            />
          ))}
      </div>
    </section>
  );
};

export default Page;
